import { Formik, Form } from 'formik'

import { FormInner } from './form.component'
import { IAccountSubcriptionPricesForm } from 'src/types'

import { accountSubscriptionPricesSchema } from 'src/common/validations'
import { useAccountDefaultSubscriptionPrices, useUpdateAccountSupbscriptionPrices } from 'src/hooks'

interface IProps {
  handleClose: () => void
  accountId: string
}

export const AccountPricesForm = ({ handleClose, accountId }: IProps) => {
  const { data: defaultPrices, isLoading } = useAccountDefaultSubscriptionPrices(accountId)
  const { mutateAsync: update } = useUpdateAccountSupbscriptionPrices(accountId)

  const handleSubmit = async (values: IAccountSubcriptionPricesForm) => {
    const resp = await update({
      plus_1m: values.plus_1m?.id!,
      plus_12m: values.plus_12m?.id!,
      premium_1m: values.premium_1m?.id!,
      premium_12m: values.premium_12m?.id!,
    })
    if (!resp) return

    handleClose()
  }

  if (isLoading) {
    return null
  }

  return (
    <Formik
      initialValues={
        defaultPrices || {
          plus_1m: null,
          plus_12m: null,
          premium_1m: null,
          premium_12m: null,
        }
      }
      validationSchema={accountSubscriptionPricesSchema}
      onSubmit={handleSubmit}
    >
      <Form>
        <FormInner />
      </Form>
    </Formik>
  )
}
